export default __webpack_public_path__ + "static/media/ct.2b467f52.png";